import type { ApolloError } from "@apollo/client";
import type { Atom, ExtractAtomValue } from "jotai";
import { atom, useAtomValue } from "jotai";
import type { ReactElement } from "react";
import type { IRateLimitInfo } from "types/graphqlTypes";

export type RunScreenerQueryState = {
  latency?: number;
  loading?: boolean;
  lastRunAt?: Date;
  error?: ApolloError | Error | null;
  rateLimit?: IRateLimitInfo | null;
};

export const runScreenerQueryStateAtom = atom<RunScreenerQueryState | null>(null);
export type RunScreenerQueryStateAtomValue = RunScreenerQueryState | null;

export interface AtomValueProps<A extends Atom<unknown>, AV = ExtractAtomValue<A>> {
  atom: A;
  children: (value: AV) => ReactElement | null;
}

export function AtomValue<A extends Atom<unknown>>({ atom, children }: AtomValueProps<A>) {
  const value = useAtomValue<A>(atom);
  return children(value);
}
